import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { DeleteEmailTemplateDrawerDataType } from './delete-email-template-drawer.component';

export const useDeleteEmailTemplateDrawer = () =>
  useDrawer<DeleteEmailTemplateDrawerDataType>();
